exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".manageUserPage__table___3dEy8 {\n  padding-top: 39px; }\n\n.manageUserPage__user-id___FvX2N {\n  font-size: 10px; }\n\n.manageUserPage__profile-link___OGOtg {\n  color: #3c00f9 !important; }\n", ""]);

// exports
exports.locals = {
	"table": "manageUserPage__table___3dEy8",
	"user-id": "manageUserPage__user-id___FvX2N",
	"profile-link": "manageUserPage__profile-link___OGOtg"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/routes/Admin/ManageUserPage/manageUserPage.scss
// module id = 1885
// module chunks = 6